export const menuB2BAccountItems = [
  {
    href: 'header.menu.profile.url',
    id: 'header.subheader.account.profile',
  },
  {
    href: 'header.menu.settings.url',
    id: 'header.subheader.account.settings',
  },
  {
    href: 'header.menu.account.url',
    id: 'header.subheader.account.orders',
  },
  {
    href: 'header.menu.invoices.url',
    id: 'header.subheader.account.invoices',
  },
  {
    href: 'header.menu.lists.url',
    id: 'header.menu.lists',
    dataQa: 'selectUserListsB2b',
  },
  {
    hasSeparator: true,
    href: 'header.menu.logout.url',
    id: 'header.subheader.account.logout',
  },
];

export const menuAccountItems = (
  isAuthenticated,
  isB2B,
  ffProServicesInvoices,
) =>
  menuB2BAccountItems
    .filter(
      ({ id }) => isAuthenticated || id !== 'header.subheader.account.logout',
    )
    .filter(({ id }) =>
      id !== 'header.subheader.account.invoices'
        ? true
        : isB2B && ffProServicesInvoices,
    );
